export default __webpack_public_path__ + "static/media/WNo.8-2.d5762966.jpg";